export default __webpack_public_path__ + "static/business-theme-d32650f44c49dc1af75f2677139e9151.jpg";